let useScrollbarWidthInitialized = false;
function useScrollbarWidth() {
  const setScrollbarWidth = () => {
    if (window && document) {
      const scrollbarWidthTemp = window.innerWidth - document.body.clientWidth;
      const scrollbarWidth = scrollbarWidthTemp > 0 ? scrollbarWidthTemp : 0;
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    }
  };
  if (!useScrollbarWidthInitialized) {
    setScrollbarWidth();
    useScrollbarWidthInitialized = true;
  }
  return {
    setScrollbarWidth
  };
}

export { useScrollbarWidth };
